import './style.scss';
import Tabs from './tabs.js';

export default Tabs;